import React, { useContext, useState } from "react";
import styles from "../../communityModule/styles/communityItem.module.css";
import globalStyles from "../../globalModule/styles/global.module.css";
import Link from "next/link";
import Image from "next/legacy/image";
import { Store } from "@store";
import { NoSsr } from "@mui/material";
import { COMMUNITY_MEMBER_ROLES, HTTP_STATUS_CODES } from "@utils/constants";
import { formatNumber } from "@utils/metrics/timeFunction";
import defaultCommitteePic from "@public/assets/images/committee.png";
import defaultCoverPic from "../../../public/assets/images/final_coverPic.jpeg";
import { requestToJoin } from "../queries/community.queries";
import BlockedUserModal from "src/globalModule/views/blockedUserModal";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
export default function CommunityItem({
  currentValue,
  index,
  toggleModal,
  setCommunityID,
  communitiesState,
  setCommunitiesState
}) {
  const {
    t
  } = useTranslation();
  const {
    state
  } = useContext(Store);
  const router = useRouter();
  const loggedInUser = state.user;
  const cover = currentValue?.coverPic ?? defaultCoverPic;
  //const smallScreen = useMediaQuery("(max-width:600px)");
  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  async function joinCommunity(id, index) {
    if (loggedInUser.authType == null) {
      toggleModal();
      return () => {};
    }
    setCommunityID(id);
    const obj = {
      communityID: id,
      accessToken: loggedInUser.accessToken
    };
    const res = await requestToJoin(obj);
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    if (setCommunitiesState) {
      const newArray = [...communitiesState];
      newArray[index].CommunityMember = res.response;
      setCommunitiesState(newArray);
    }
  }
  function ButtonText({
    role
  }) {
    if (role === COMMUNITY_MEMBER_ROLES.GENERAL || role === COMMUNITY_MEMBER_ROLES.OWNER || role === COMMUNITY_MEMBER_ROLES.ADMIN || role === COMMUNITY_MEMBER_ROLES.MODERATOR) {
      return `${t("joined")}`;
    } else if (role === COMMUNITY_MEMBER_ROLES.INVITED) {
      return `${t("invited")}`;
    } else if (role === COMMUNITY_MEMBER_ROLES.REQUESTED) {
      return `${t("requested")}`;
    } else {
      return `${t("join")}`;
    }
  }
  return <>
      {/* <Grid
        item
        xs={6}
        key={index.toString()}
        sx={{
          paddingLeft: "0px !important",
          paddingTop: "0px !important",
          // marginRight: "2px",
          // marginBottom: "20px",
        }}
       > */}
      <div
    // key={index.toString()}
    className={`${styles.singleCommunityContainer}`}>
        <Link scroll={false} href={`/community/${currentValue.urlExtension}`} passHref rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="communityItem.jsx">
          <div className={styles.communityCoverPic}>
            <Image src={cover} alt={`${currentValue.name}-${t("cover")}`} width={600} height={300} objectFit="cover" data-sentry-element="Image" data-sentry-source-file="communityItem.jsx" />
          </div>

          <div className={styles.communityDpContainer}>
            <div className={styles.communityDp}>
              <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="communityItem.jsx">
                <div className={styles.avatar}>
                  <Image src={currentValue?.dp || defaultCommitteePic} alt={`${currentValue.name} ${t("dp")}`} width="80" height="80" objectFit="cover" style={{
                  borderRadius: "50%"
                }} data-sentry-element="Image" data-sentry-source-file="communityItem.jsx" />
                </div>
              </NoSsr>
            </div>
          </div>

          <div className={styles.title}>
            <span className={styles.ellipsizedTitle}>{currentValue.name}</span>

            <p className={styles.memberNo}>
              {formatNumber(currentValue.CommunityMetric.memberNo)}{" "}
              {t("members")}
            </p>
          </div>
        </Link>

        <button onClick={() => joinCommunity(currentValue.communityID, index)} className={`${currentValue?.CommunityMember ? globalStyles.utsavButtonOutlined : globalStyles.utsavButtonFilled} ${styles.joinButton}`}>
          <ButtonText role={currentValue?.CommunityMember?.role} data-sentry-element="ButtonText" data-sentry-source-file="communityItem.jsx" />
        </button>
      </div>
      {/* </Grid> */}

      {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg={t("contact-utsav")} rejectMsg={t("cancel")} />}
    </>;
}